/**
 * Created by jmulder on 27/07/17.
 */

export function isoDate() : string {

  var month: String;
  var date: String;

  let year = new Date().getFullYear().toString();

  let m = (new Date().getMonth()) + 1;
  if( m < 10 ) {
    month = "0" + m;
  } else {
    month = m.toString();
  }

  let d = new Date().getDate();
  if(d < 10 ) {
    date = "0" + d;
  } else {
    date = d.toString();
  }

  return year + '-' + month + '-' + date;
}
